// removed by extract-text-webpack-plugin
module.exports = {"controls":"style__controls___2TiQ6","downloadIcon":"style__downloadIcon___2zBK6","linkIOS":"style__linkIOS___NS60t","linkAndroid":"style__linkAndroid___8qBbl","shadow":"style__shadow___1mRTQ"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/store-button/style.css
// module id = 1115
// module chunks = 0